import { useDispatch } from "react-redux";
import { Delete } from "@mui/icons-material";
import { TableRow, TableCell, IconButton, Box, Chip } from "@mui/material";
import { Link } from "react-router-dom";
import { currencyFormatter } from "../../../utils/formatUtils";
import {
  deleteCurrentProject,
  toggleProjectActiveStatus,
} from "../../../actions/projectsActions";
import LLCClassificationBadge from "../../../components/LLCClassificationBadge";
import { useState } from "react";

const ProjectsListItem = (props) => {
  const dispatch = useDispatch();

  const [isActive, setIsActive] = useState(Boolean(props.isActive ?? true));

  const handleDelete = (e) => {
    e?.preventDefault();
    dispatch(
      deleteCurrentProject({ id: props._id, callback: () => props.onDelete() })
    );
  };

  const handleToggleActive = (e) => {
    const newActiveStatus =
      e.target?.checked !== undefined ? e.target.checked : !isActive;
    setIsActive(newActiveStatus);

    dispatch(
      toggleProjectActiveStatus({
        id: props._id,
        isActive: newActiveStatus,
        callback: () => {
          if (props.onUpdate) props.onUpdate();
        },
      })
    );
  };

  return (
    <TableRow>
      <TableCell>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <Link to={props._id}>{props.name}</Link>
          <LLCClassificationBadge vehiculo={props.vehiculo} />
        </Box>
      </TableCell>
      <TableCell>
        {new Date(
          `${props.investmentDate?.slice?.(0, 10)}T00:00:00`
        )?.toLocaleDateString()}
      </TableCell>
      <TableCell>{props.isInvestmentUSD ? "USD" : "MXP"}</TableCell>
      <TableCell>{currencyFormatter.format(props.investment)}</TableCell>
      <TableCell align="center">{props.percentageIde ?? "-"}%</TableCell>
      {/* <TableCell align="center">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Chip
            label={isActive ? "Activo" : "Inactivo"}
            color={isActive ? "success" : "default"}
            size="small"
            variant="outlined"
            onClick={handleToggleActive}
            sx={{ cursor: "pointer" }}
          />
        </Box>
      </TableCell> */}
      <TableCell onClick={handleDelete}>
        <IconButton>
          <Delete />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default ProjectsListItem;
